import { Link } from "react-router-dom";
import { ArrowUpRight, ExternalLink } from "lucide-react";
import { PARENT_SITE, PRODUCTS, SERVICES } from "../lib/site";
import { LogoChip } from "./blocks";

const companyLinks = [
  { label: "About Us", to: "/about" },
  { label: "Our Group", to: "/about/our-group" },
  { label: "Industries", to: "/industries" },
  { label: "Technology & Security", to: "/technology-security" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Cookie Notice", to: "/cookie-notice" },
  { label: "Terms of Use", to: "/terms" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-ink text-white border-t border-white/10" data-testid="site-footer">
      <div className="shell pt-16 pb-8 md:pt-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <LogoChip size="h-10" />
            <p className="mt-6 text-softgrey leading-relaxed max-w-sm">
              Digital products and enterprise technology solutions for the Nigerian market — part of the Softline group.
            </p>
            <a
              href={PARENT_SITE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-group-link"
              className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-softgrey hover:text-lime transition-colors duration-200"
            >
              Softline Technologies and Services AB · Sweden <ExternalLink size={13} />
            </a>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.25em] text-lime">Products</h3>
            <ul className="mt-5 space-y-3">
              {PRODUCTS.map((p) => (
                <li key={p.slug}>
                  <Link to={`/products/${p.slug}`} data-testid={`footer-product-${p.slug}`} className="text-[15px] text-white/80 hover:text-lime transition-colors duration-200">
                    {p.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/products" className="text-[15px] text-white/80 hover:text-lime transition-colors duration-200">
                  All Products
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-mono text-[11px] uppercase tracking-[0.25em] text-lime">Services</h3>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-[15px] text-white/80 hover:text-lime transition-colors duration-200">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3 grid grid-cols-2 gap-8 md:block">
            <div>
              <h3 className="font-mono text-[11px] uppercase tracking-[0.25em] text-lime">Company</h3>
              <ul className="mt-5 space-y-3">
                {companyLinks.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} data-testid={`footer-company-${l.to.replace(/\//g, "-") || "home"}`} className="text-[15px] text-white/80 hover:text-lime transition-colors duration-200">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="md:mt-8">
              <h3 className="font-mono text-[11px] uppercase tracking-[0.25em] text-lime">Legal</h3>
              <ul className="mt-5 space-y-3">
                {legalLinks.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} data-testid={`footer-legal-${l.to.replace(/\//g, "-")}`} className="text-[15px] text-white/80 hover:text-lime transition-colors duration-200">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-[13px] text-softgrey/80 max-w-2xl leading-relaxed">
            © {year} Softline Technologies and Services Nigeria Limited. All rights reserved. A subsidiary of Softline
            Technologies and Services AB, Sweden.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-softgrey/60">
            Abuja · Lagos, Nigeria — RC 8778015
          </p>
        </div>
      </div>
    </footer>
  );
}
